import sectionCardCash from "../assets/section-card-cash.svg?inline";
import sectionCardFund from "../assets/section-card-fund.svg?inline";
import sectionCardPay from "../assets/section-card-pay.svg?inline";
import type { TChoiceCardData } from "./choice-card";
import { EQuestionnairePath } from "./questionnaire-flow";

export const QUESTIONNAIRE_CHOICES: readonly TChoiceCardData[] = [
	{
		path: EQuestionnairePath.FUND,
		icon: sectionCardFund,
		desktopLabel: "Get funding",
		mobileLabel: "Fund a purchase order, bill or invoice",
	},
	{
		path: EQuestionnairePath.PAYMENTS,
		icon: sectionCardPay,
		desktopLabel: "Streamline payments with AI",
		mobileLabel: "Pay multiple suppliers",
	},
	{
		path: EQuestionnairePath.CASH_FLOW,
		icon: sectionCardCash,
		desktopLabel: "Optimise cash flow",
		mobileLabel: "Improve my cash flow",
	},
];
